var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":"","flat":""}},[_c('v-card-title',[_vm._v(" Channels "),_c('v-spacer')],1),_c('v-card-text',[[_c('div',{staticClass:"body-1 mb-3"},[_vm._v(_vm._s(_vm._f("emptyDash")('')))])]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }